module.exports = "/assets/data/638ef514cda4dbfc873a3ba54c76b515-GL7.data.json";